export const menuData = [
  // {
  //   meta: { label: "面板",icon:"#bg-ic-stystem" },
  //   submenus: [
  //     {
  //       path: "/dashboard",
  //       meta: { label: "控制面板", permission: "images_list", group: 1 },
  //       component: {
  //         computed: {},
  //         staticRenderFns: [],
  //         _compiled: true,
  //         beforeCreate: [null],
  //         beforeDestroy: [null],
  //         __file: "src/layouts/RouterView/index.vue",
  //         _Ctor: {},
  //       },
  //     },
  //   ],
  // },
  {
    meta: { label: "主机", icon:"#bg-ic-server" },
    submenus: [
      {
        path: "/vminstance",
        meta: { label: "虚拟机", permission: "servers_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "VMInstance", path: "", meta: { label: "虚拟机" } },
          {
            name: "VMInstanceCreate",
            path: "create",
            meta: { label: "虚拟机" },
          },
          {
            name: "VMInstanceAdjustConfig",
            path: "adjust-config",
            meta: { label: "虚拟机" },
          },
        ],
      },
      {
        path: "/scalinggroup",
        meta: {
          label: "弹性伸缩组",
          permission: "scalinggroups_list",
          group: 1,
        },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "ScalingGroup", path: "", meta: { label: "弹性伸缩组" } },
          {
            name: "ScalingGroupCreate",
            path: "create",
            meta: { label: "弹性伸缩组" },
          },
        ],
      },
    ],
  },
  {
    meta: { label: "镜像", icon:"#bg-ic-container" },
    submenus: [
      {
        path: "/image",
        meta: { label: "系统镜像", permission: "images_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Image", path: "", meta: { label: "系统镜像" } },
          { name: "ImageImport", path: "import", meta: { label: "系统镜像" } },
          {
            name: "ImageImportCe",
            path: "market",
            meta: { label: "系统镜像" },
          },
        ],
      },
    ],
  },
  {
    meta: { label: "存储",icon:"#bg-ic-data" },
    submenus: [
      {
        path: "/disk",
        meta: { label: "硬盘", permission: "disks_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Disk", path: "", meta: { label: "硬盘" } },
          { name: "DiskCreate", path: "create", meta: { label: "硬盘" } },
        ],
      },
      {
        path: "/disk-snapshot",
        meta: {
          label: "硬盘快照",
          t: "compute.text_101",
          permission: "snapshots_list",
          group: 1,
        },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "DiskSnapshot", path: "", meta: { label: "硬盘快照" } },
        ],
      },
      {
        path: "/instance-snapshot",
        meta: {
          label: "主机快照",
          t: "compute.text_102",
          permission: "instance_snapshots_list",
          group: 1,
        },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "InstanceSnapshot", path: "", meta: { label: "主机快照" } },
        ],
      },
      {
        path: "/snapshotpolicy",
        meta: {
          label: "自动快照策略",
          t: "compute.text_103",
          permission: "snapshotpolicy_list",
          group: 1,
        },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "SnapshotPolicy", path: "", meta: { label: "自动快照策略" } },
        ],
      },
    ],
  },
  {
    meta: { label: "网络", icon:"#bg-ic-sphere" },
    submenus: [
      {
        path: "/secgroup",
        meta: { label: "安全组", permission: "secgroups_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Secgroup", path: "", meta: { label: "安全组" } },
          { name: "SecgroupCreate", path: "create", meta: { label: "安全组" } },
        ],
      },
      {
        path: "/network2",
        meta: { label: "IP子网", permission: "networks_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Network2", path: "", meta: { label: "IP子网" } },
          { name: "NetworkCreate2", path: "create", meta: { label: "IP子网" } },
          { name: "NetworkUpdate2", path: "edit", meta: { label: "IP子网" } },
        ],
      },
      {
        path: "/eip2",
        meta: { label: "弹性公网IP", permission: "eips_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Eip2", path: "", meta: { label: "弹性公网IP" } },
          { name: "EipCreate2", path: "create", meta: { label: "弹性公网IP" } },
        ],
      },
    ],
  },
  {
    meta: { label: "密钥", icon:"#bg-ic-key" },
    submenus: [
      {
        path: "/keypair",
        meta: { label: "密钥", permission: "keypairs_list", group: 1 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [{ name: "Keypair", path: "", meta: { label: "密钥" } }],
      },
    ],
  },
  {
    meta: { label: "多云管理", icon:"#bg-ic-branch" },
    submenus: [
      {
        path: "/cloudaccount",
        meta: { label: "云账号", permission: "cloudaccounts_list", group: 9 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Cloudaccount", path: "", meta: { label: "云账号" } },
          {
            name: "CloudaccountCreate",
            path: "create",
            meta: { label: "云账号" },
          },
          {
            name: "CloudaccountUpdateBill",
            path: "updatebill",
            meta: { label: "云账号" },
          },
        ],
      },
      {
        path: "/cloudgroup",
        meta: {
          label: "云用户组",
          permission: "cloudgroup_list",
          t: "cloudenv.text_491",
          group: 9,
        },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "Cloudgroup", path: "", meta: { label: "云用户组" } },
        ],
      },
      {
        path: "/proxysetting",
        meta: { label: "代理", permission: "proxysettings_list", group: 9 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [{ name: "Proxysetting", path: "", meta: { label: "代理" } }],
      },
      {
        path: "/projectmapping",
        meta: { label: "同步策略", permission: "proxysettings_list", group: 9 },
        component: {
          computed: {},
          staticRenderFns: [],
          _compiled: true,
          beforeCreate: [null],
          beforeDestroy: [null],
          __file: "src/layouts/RouterView/index.vue",
          _Ctor: {},
        },
        children: [
          { name: "ProjectMapping", path: "", meta: { label: "同步策略" } },
        ],
      },
    ],
  },
];
